import { ToolUsageContainer } from './ToolUsageContainer';

export const ToolUsageHolder: React.FC = () => {
  return <ToolUsageContainer withFilters />;
};
